<template>
  <div class="checkout">
    <payment-view />
  </div>
</template>

<script>
// @ is an alias to /src
import PaymentView from '@/components/Checkout/Payment.vue';

export default {
  name: 'checkout',
  data() {
    return {
    }
  },
  components: {
    'payment-view' : PaymentView,
  },
  mounted() {
    this.load();
  },
  methods: {
    load:function(){
    },
  }
}
</script>

<style scoped>
  .checkout {
    float:left;
    width: 100%;
    height: 100%;
  }

</style>
